// extracted by mini-css-extract-plugin
module.exports = {"reviewsList":"ReviewsList_reviewsList__U8vFs"};